import { EstateDesignType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import EstateDesignContainer from "@/domains/estate/containers/tablet/tabs/design/EstateDesignContainer.tsx";

type Props = { onClose: () => void };

export default function EstateDesignWallsContainer({ onClose }: Props) {
  return <EstateDesignContainer type={EstateDesignType.Wall} onClose={onClose} />;
}
